import React, { useCallback, useContext, useEffect, useState } from 'react';

import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import UserMembershipsTable from '../components/membership/UserMembershipsTable';
import { LoginContext } from '../../../App';
import { getUserMembershipsPaged } from '../../../services/b2b-users-apiService';
import B2BButtonGroup from '../../b2b-common/B2BButtonGroup';
import { Add } from '@mui/icons-material';
import UserNewMemberOfOrganization from '../components/membership/UserNewMemberOfOrganization';
import Membership from '../components/membership/Membership';

const UserMembershipManagement = ({ user, onUpdatedUserMembership, onNewUserMembership }) => {

    const { loginData } = useContext(LoginContext);
    const [error, setError] = useState(null);

    const [page, setPage] = useState(1);
    const [loadingPage, setLoadingPage] = useState(null);
    const [pagesCount, setPagesCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [currentUser, setCurrentUser] = useState(user);
    const [loadingUserMembership, setLoadingUserMembership] = useState(false);
    const [userMemberships, setUserMemberships] = useState([]);
    const [currentUserMembership, setCurrentUserMembership] = useState(null);
    const [refresh, setRefresh] = useState(true);

    const [showNewMemberOfOrganization, setShowNewMemberOfOrganization] = useState(false);

    const [searchFields, setSearchFields] = useState({
        organizationName: '',
    });

    const fetchAllUserOrganizationUUIDs = useCallback(async (uuid) => {
        try {
            if (loginData) {
                const { accessToken } = loginData;
                const data = await getUserMembershipsPaged(uuid, 0, 100, null, accessToken);
                user.userOrganizations = data.content.map(item => item.organization.organizationUUID);
            }
        } catch (error) {
            setError(error.message);
        }
    });

    useEffect(() => {
        if (user) {
            fetchAllUserOrganizationUUIDs(user.userUuid);
        }
    }, [user]);

    const fetchUsersMembershipData = useCallback(async (uuid, page) => {
        try {
            if (loginData) {
                setLoadingPage(page);
                const { accessToken } = loginData;
                const data = await getUserMembershipsPaged(uuid, page - 1, rowsPerPage, searchFields, accessToken);
                setUserMemberships(data);
                setPagesCount(data.totalPages);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setLoadingPage(null);
        }
    }, [loginData, searchFields]);

    useEffect(() => {
        if ((currentUser) && (refresh) && (page !== 0)) {
            fetchUsersMembershipData(currentUser.userUuid, page);
            setRefresh(false);
        }
    }, [currentUser, page, refresh, fetchUsersMembershipData]);

    const handleSelectedUserMembership = (userMembershipRowData) => {
        setCurrentUserMembership(null);
        const memberSelected = userMemberships.content.find(member => member.organization.organizationUUID === userMembershipRowData.id);
        setCurrentUserMembership(memberSelected);
    }

    const handleCloseUserMembership = () => {
        setCurrentUserMembership(null);
    }

    const handleMembershipUpdate = () => {
        setRefresh(true);
    }

    const handleMembershipRemoved = () => {
        setPage(1);
        setRefresh(true);
    }

    const handleNewMemberOfOrganization = () => {
        setShowNewMemberOfOrganization(true);
    }

    const handleCloseNewMemberOfOrganization = () => {
        setShowNewMemberOfOrganization(false);
    }

    const handleNewMemberCreated = () => {
        setRefresh(true);
    }

    const handlePageChange = (event, value) => {
        setPage(value);
        setRefresh(true);
    };

    const buttonConfigs = [
        {
            label: 'Member of New Organization',
            onClick: () => handleNewMemberOfOrganization(),
            icon: <Add />,
        },
    ];

    return (
        <>
            <B2BFormContainer buttonsConfig={null} className="user-membership-management-form">
                {error && <p>{error}</p>}
                {userMemberships && (
                    <UserMembershipsTable
                        memberships={userMemberships}
                        onSelectedUserMembership={handleSelectedUserMembership}
                        pagesCount={pagesCount}
                        currentPage={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        tableLoading={loadingUserMembership}
                        pageLoading={loadingPage}
                    />
                )}
            </B2BFormContainer>
            <B2BButtonGroup buttonConfigs={buttonConfigs} />
            {showNewMemberOfOrganization &&
                <UserNewMemberOfOrganization
                    onNewMemberCreated={handleNewMemberCreated}
                    user={currentUser} onClose={handleCloseNewMemberOfOrganization}
                />}
            {currentUserMembership &&
                <Membership
                    membershipData={currentUserMembership}
                    onClose={handleCloseUserMembership}
                    onMembershipUpdate={handleMembershipUpdate}
                    onMembershipRemove={handleMembershipRemoved}
                />
            }
        </>
    );
}
export default UserMembershipManagement;